import React from 'react';
import IconLinkUrl, { ReactComponent as IconLink } from './icon-link.svg';
import './consentTypo.scss';

const CONSENT_LINKS = {
  tos: '//legal.kr.riotgames.com/tos',
  privacy: '//legal.kr.riotgames.com/signup/privacy',
  external: '//legal.kr.riotgames.com/signup/external',
  'u18/privacy': '//legal.kr.riotgames.com/u18/privacy',
  'u18/usage': '//legal.kr.riotgames.com/u18/usage',
  'u14/pi': '//legal.kr.riotgames.com/u14/pi',
  'u14/privacy': '//legal.kr.riotgames.com/u14/privacy',
  'u14/usage': '//legal.kr.riotgames.com/u14/usage'
};

const linkTo = (e, url) => {
  e.preventDefault();
  window.open(url);
};

const ConsentTypo = ({ strongText, text, consentName }) => (
  <span className="consentTypo">
    <span>
      <strong>{strongText}</strong>
      {text}
    </span>
    <span className="consent-link-wrapper">
      <button className="consent-link" onClick={(ev) => linkTo(ev, CONSENT_LINKS[consentName])}>
        <IconLink />
      </button>
    </span>
  </span>
);

export default ConsentTypo;
